import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Improvisás clases constantemente', 'Perdés horas pensando qué enseñar', 'No sabés cómo estructurar una clase clara', 'Tus alumnos se aburren o abandonan', 'Tenés conocimiento pero no un sistema', 'Repetís contenido sin progresión', 'Te sentís saturado preparando clases', 'No podés escalar porque todo depende de vos'];
  return <section className="py-12 md:py-20 bg-brand-50 relative overflow-hidden" data-id="element-196">
      {/* Korean decorative watermarks */}
      <div className="absolute top-10 left-4 md:left-16 text-brand-200/60 text-6xl md:text-9xl font-extrabold select-none pointer-events-none rotate-[-8deg]" data-id="element-197">
        문제
      </div>
      <div className="absolute bottom-10 right-4 md:right-16 text-brand-200/60 text-6xl md:text-9xl font-extrabold select-none pointer-events-none rotate-[6deg]" data-id="element-198">
        해결
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-199">
        <div className="max-w-4xl mx-auto" data-id="element-200">
          <div className="text-center mb-6 md:mb-12" data-id="element-201">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-100 text-red-700 font-bold mb-3 md:mb-4 text-xs md:text-sm" data-id="element-202">
              <span className="font-extrabold" data-id="element-203">솔직하게</span>
              <span data-id="element-204">· Hablemos en serio</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-brand-950 mb-3 md:mb-4" data-id="element-205">
              Esto es para vos si…
            </h2>
            <div className="flex items-center justify-center gap-2" data-id="element-206">
              <div className="w-2 h-2 rounded-full bg-blue-500" data-id="element-207"></div>
              <div className="w-12 md:w-16 h-1 bg-accent-500 rounded-full" data-id="element-208"></div>
              <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-209"></div>
            </div>
          </div>

          <div className="bg-white rounded-2xl md:rounded-3xl shadow-soft p-4 md:p-12 border border-brand-100 relative" data-id="element-210">
            {/* Corner hangul accent */}
            <div className="absolute -top-3 -right-3 w-12 h-12 md:w-16 md:h-16 rounded-full bg-accent-500 flex items-center justify-center text-white font-extrabold text-lg md:text-2xl shadow-lg rotate-12 border-4 border-white" data-id="element-211">
              X
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 md:gap-y-4" data-id="element-212">
              {points.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.04
            }} className="flex items-start gap-3 p-2.5 md:p-4 rounded-xl md:rounded-2xl hover:bg-red-50/50 transition-colors border border-transparent hover:border-red-100" data-id="element-213">
                  <div className="bg-red-100 p-1 md:p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-214">
                    <XCircle className="w-4 h-4 md:w-5 md:h-5 text-red-500" data-id="element-215" />
                  </div>
                  <span className="text-brand-800 font-medium text-sm md:text-lg leading-snug" data-id="element-216">
                    {point}
                  </span>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="mt-5 md:mt-10 bg-brand-900 text-white p-4 md:p-6 rounded-xl md:rounded-2xl flex items-center gap-3 md:gap-4 justify-center text-center shadow-lg relative overflow-hidden" data-id="element-217">
              <div className="absolute -right-4 -top-4 text-brand-800/30 text-6xl md:text-7xl font-extrabold select-none pointer-events-none" data-id="element-218">
                해결책
              </div>
              <AlertCircle className="w-6 h-6 md:w-8 md:h-8 text-accent-400 shrink-0 hidden sm:block relative z-10" data-id="element-219" />
              <p className="text-sm md:text-xl font-bold leading-snug relative z-10" data-id="element-220">
                Si te identificás con al menos una,{' '}
                <span className="text-accent-400" data-id="element-221">
                  este sistema es para vos.
                </span>
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}